/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import * as c from './constant';

export const getList = (payload, callback) =>
  req.list(
    c.GET_LIST,
    'api/v1/rpt/administrator/machineries/tax_credits',
    payload,
    callback
  );

export const validateApplication = (payload, callback) =>
  req.item(
    c.VALIDATE_APPLICATION,
    `api/v1/rpt/administrator/machineries/tax_credits/applications/validate`,
    callback,
    payload
  );

export const createTaxCredit = (payload, callback) =>
  req.create(
    c.CREATE_DATA,
    `api/v1/rpt/administrator/machineries/tax_credits`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const getTaxCreditLogs = (id, payload, callback) =>
  req.list(
    c.GET_TAX_CREDIT_LOGS,
    `api/v1/rpt/administrator/machineries/tax_credits/${id}/logs`,
    payload,
    callback
  );

export const updateTaxCredit = (id, payload, callback) =>
  req.update(
    c.UPDATE_DATA,
    `api/v1/rpt/administrator/machineries/tax_credits/${id}/update`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const validateTransferReceiver = (id, payload, callback) =>
  req.item(
    c.VALIDATE_APPLICATION_TRANSFER,
    `api/v1/rpt/administrator/machineries/tax_credits/${id}/transfer/validate`,
    callback,
    payload
  );

export const transferTaxCredit = (id, payload, callback) =>
  req.create(
    c.TRANSFER_TAX_CREDIT,
    `api/v1/rpt/administrator/machineries/tax_credits/${id}/transfer`,
    payload,
    callback
  );

export const removeData = (id, payload, callback) =>
  req.remove(
    c.REMOVE_DATA,
    `api/v1/rpt/administrator/machineries/tax_credits/${id}`,
    callback,
    payload
  );
